module.exports = __webpack_public_path__ + "assets/img/wechatqrcode.72379e87.jpg";